import './addAppointmentBox.css';
import { Button } from './Button';
import React, { useState } from 'react';

export const AddAppointmentBox = (props) => {

    const [aptClient, setAptClient]   = useState('');
    const [startDate, setStartDate]   = useState('');
    const [startTime, setStartTime]   = useState('');
    const [label, setLabel]           = useState('');
    const [details, setDetails]       = useState('');

    const sortedClients = [...props.clientList].sort((a, b) => a.name.localeCompare(b.name));

    const gatherFields = () => {
        let aptHourSplit = Number(startTime.toString().split(':')[0]) + 4;
        let aptMinSplit = startTime.toString().split(':')[1];
        if (aptHourSplit.toString().length < 2) aptHourSplit = "0" + aptHourSplit;

        let aptStartDatetime = startDate + "T" + startTime;
        let aptEndDatetime = `${startDate}T${aptHourSplit}:${aptMinSplit}`;

        let addedBy = props.userList.filter(e => e.email === props.user.email)[0].name;

        props.addAppointment(aptClient, aptStartDatetime, aptEndDatetime, details, addedBy, label);
        alert("Appointment added successfully");
    }

    return (
        <div className="addAppointmentBoxDiv">
            <a name="addAppointmentTarget"></a>
            <h2>Add Appointment</h2>
            <div className="formSep"></div>
            <div className="addAppointmentFormDiv">

                <label htmlFor="aptClientSelect">Client: </label>
                <select id="aptClientSelect" value={aptClient} onChange={e => setAptClient(e.target.value)}>
                    <option value="">-- Select Client --</option>
                    {sortedClients.map(c => (
                        <option key={c.name} value={c.name}>{c.name}</option>
                    ))}
                </select>

                <label htmlFor="appointmentStartDate">Start Date: </label>
                <input
                    type="date" id="appointmentStartDate" name="appointmentStartDate"
                    value={startDate}
                    onChange={e => setStartDate(e.target.value)}
                />

                <label htmlFor="appointmentStartTime">Start Time: </label>
                <input
                    type="time" id="appointmentStartTime" name="appointmentStartTime"
                    value={startTime}
                    onChange={e => setStartTime(e.target.value)}
                />

                <label htmlFor="appointmentLabelInput">Appointment Label: </label>
                <input
                    type="text" id="appointmentLabelInput"
                    placeholder="Heart Doctor, Dentist, Eye Doctor, etc."
                    value={label}
                    onChange={e => setLabel(e.target.value)}
                />

                <label htmlFor="appointmentDetails">Details: </label>
                <textarea
                    id="appointmentDetails" name="appointmentDetails"
                    placeholder="Enter appointment details and comments here"
                    value={details}
                    onChange={e => setDetails(e.target.value)}
                />

                <div className="aptConfirmRow">
                    <Button onClick={() => gatherFields()} type="button"
                        buttonStyle="btn--success--solid" buttonSize="btn--medium">
                        Confirm Appointment
                    </Button>
                </div>
            </div>
        </div>
    )
}
